import React, {useState, useEffect} from 'react'
import { useDispatch } from 'react-redux';
import { connect } from 'react-redux';
import Swal from 'sweetalert2'
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    Row,
    Col,
    Modal, 
    ModalBody,
    ModalFooter,
    Badge
  } from "reactstrap";

import { EditorState, convertToRaw, ContentState, convertFromHTML, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import  Select  from 'react-select';
import { customDropdown } from 'util/reactCustomStyles';

import { createDatCourseLessons, updateDatCourseLessons, createDatCourseLessonsReset, updateDatCourseLessonsReset, fetchDatCourses } from 'redux/ManageDatCourses/ManageDatCoursesActions';

const AddDatCourseCategoryLessonsModal = (props) => {

    const dispatch = useDispatch()

    let modalAddDatCourseCategoryLessons = props.modalAddDatCourseCategoryLessonsModal;
    let toggleAddDatCourseCategoryLessons = props.toggleAddDatCourseCategoryLessonsModal;
    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    const handleChange = (state) => {
        setEditorState(state);
        const lessonDetail = lessonDetails;

        
        lessonDetail.body = JSON.stringify(convertToRaw(state.getCurrentContent()));
        setLessonDetails(lessonDetail);
        
        

    };
    
    useEffect(() => {
        console.log(props)
        setSelectedLessonThumbnail(null)
        setSelectedFiles(null)
        setSelectedLessonVideo("")
        setLessonDetails({...lessonDetails, ...{category : props.categoryId}});

        if(props.editCourseCategoryLessons){
            console.log(props.lessonToUpdate)
            if(props.lessonToUpdate.body != ""){
                const editorState = EditorState.createWithContent(convertFromRaw(JSON.parse(props.lessonToUpdate.body)));
                setEditorState(editorState)
            }

            const lessonDetail = lessonDetails;
            lessonDetail.title = props.lessonToUpdate.title;
            lessonDetail.visibility = props.lessonToUpdate.visibility;
            lessonDetail.availability = props.lessonToUpdate.availability;
            lessonDetail.body = props.lessonToUpdate.body;
            lessonDetail.id = props.lessonToUpdate.id;
            lessonDetail.category = props.lessonToUpdate.categoryId
            lessonDetail.oldCategory = props.lessonToUpdate.categoryId

            lessonDetail.videoType = props.lessonToUpdate.videoType
            
            lessonDetail.video = props.lessonToUpdate.video
            setSelectedLessonVideo(props.lessonToUpdate.video)

            setLessonDetails(lessonDetail);

            
        }
   

        
    }, [modalAddDatCourseCategoryLessons])
     

    // const onClickCreateLesson = (e) => {
    //     e.preventDefault()
    //     console.log(props.selectedCategory)
    // }

    const visibilityOptions = [{value: "draft", label : "Draft"},{value: "published", label : "Published"}];
    const availabilityOptions = [{value: "unlock", label : "Unlock"},{value: "lock", label : "Lock"},{value: "deactivate", label : "Deactivate"}];


    // const [categoryLessonsLists , setCategoryLessonsLists] = useState([])

    const handleCreateCategoryLessons = (e) => {

        e.preventDefault()

        // Swal.showLoading()
        
        Swal.showLoading()

        // if(lessonDetails.title == "" || lessonDetails.visibility == "" || lessonDetails.availability == "")
        if(lessonDetails.title == "" || lessonDetails.visibility == "")
        {
            Swal.fire({
                title: 'Failed!',
                text: 'Please fill all the required field!',
                icon : 'error',
                timer: 3000
                
              }
            ).then((result) => {
             
               
            })
        }
        else{
            const formData = new FormData();
            formData.append('title', lessonDetails.title);
            formData.append('category', lessonDetails.category);
            formData.append('thumbnail', lessonDetails.thumbnail);
            formData.append('body', lessonDetails.body);
            formData.append('visibility', lessonDetails.visibility);
            formData.append('availability', lessonDetails.availability);
            formData.append('video', lessonDetails.video);
            formData.append('videoType', lessonDetails.videoType);
            if (selectedFiles) {
                for (let i = 0; i < selectedFiles.length; i++) {
                  formData.append('files', selectedFiles[i]);
                }
            }
            formData.append('datCourseId',props.courseData.datCourseId)
            formData.append('handle', props.userDetails.handle);
            dispatch(createDatCourseLessons(formData))
        }
        
        
    }

    const [selectCategoryLists, setSelectCategoryLists] = useState([])

    useEffect(() => {

        const categoryArr = [];
      
        props.items.map((item) => {
            categoryArr.push ({
                value : item.id,
                label : item.text
            })
        })

        setSelectCategoryLists(categoryArr)
        
        
    }, [modalAddDatCourseCategoryLessons])

    useEffect(() => {

        // if(typeof props.selectedCategory.lessons != "undefined") {
            
        //     setCategoryLessonsLists(props.selectedCategory.lessons)
        // }

        const categoryArr = [];

        props.items.map((item) => {
            categoryArr.push ({
                value : item.id,
                label : item.text
            })
        })

        setSelectCategoryLists(categoryArr)

        
    }, [])

    const [lessonDetails, setLessonDetails] = useState({ 
        id : "",
        title : "",
        thumbnail : "",
        video: "",
        visibility : "",
        availability: "",
        body : "",
        category: "",
        oldCategory : "",
        videoType: "vimeo"
        
    });

    const [selectedLessonThumbnail, setSelectedLessonThumbnail] = useState(null)
    const [selectedLessonVideo, setSelectedLessonVideo] = useState("")
    
    const handleImageChange = (event) => {
        const lessonDetail = lessonDetails;

        let imageDetails = ""

        lessonDetail.thumbnail = event.target.files[0];
        imageDetails = lessonDetail.thumbnail
    
        const fileSizeInMB = imageDetails / (1024 * 1024);
        const maxSizeInMB = 5;
        if (fileSizeInMB > maxSizeInMB) {
            Swal.fire({
                title: 'Failed!',
                text: 'File size exceeds the maximum limit of 5MB.',
                icon: 'error',
                timer: 3000
            });
            return;
        }
        
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        if (!allowedTypes.includes(imageDetails.type)) {
            Swal.fire({
                title: 'Failed!',
                text: 'Only image files (JPEG, PNG, JPG) are allowed.',
                icon: 'error',
                timer: 3000
            });
            return;
        }

        if (imageDetails) {
            const reader = new FileReader();

            reader.onload = function (e) {

                setSelectedLessonThumbnail(e.target.result);
                
            };

            reader.readAsDataURL(imageDetails);
        } else {

            setSelectedLessonThumbnail(null);
            
        }
        
        
        setLessonDetails(lessonDetail);
    };

    const handleVideoChange = (event) => {
        const lessonDetail = lessonDetails;

        let videoDetails = ""

        lessonDetail.video = event.target.files[0];
        lessonDetail.videoType = "upload"
        videoDetails = lessonDetail.video
    
        // const fileSizeInMB = videoDetails / (1024 * 1024);
        // const maxSizeInMB = 5;
        // if (fileSizeInMB > maxSizeInMB) {
        //     Swal.fire({
        //         title: 'Failed!',
        //         text: 'File size exceeds the maximum limit of 5MB.',
        //         icon: 'error',
        //         timer: 3000
        //     });
        //     return;
        // }
        
        const allowedTypes = ['video/mp4', 'video/webm', 'video/ogg'];
        if (!allowedTypes.includes(videoDetails.type)) {
            Swal.fire({
                title: 'Failed!',
                text: 'Only video files (MP4, WEBM, OGG) are allowed.',
                icon: 'error',
                timer: 3000
            });
            return;
        }

        if (videoDetails) {
            const reader = new FileReader();

            reader.onload = function (e) {

                setSelectedLessonVideo(e.target.result);
                
            };

            reader.readAsDataURL(videoDetails);
        } else {

            setSelectedLessonVideo("");
            
        }
        
        setLessonDetails(lessonDetail);
    };

    const handleLessonVimeoChange = (e) => {
        const lessonDetail = lessonDetails;
        lessonDetail.video = e.target.value;
        lessonDetail.videoType = 'vimeo';
        console.log(lessonDetail)
        setLessonDetails(lessonDetail);
        setSelectedLessonVideo(e.target.value)
    }

    const handleLessonTitleChange = (event) => {
        const lessonDetail = lessonDetails;
        lessonDetail.title = event.target.value;
        setLessonDetails(lessonDetail);
    };

    const handleVisibilityChange = (event) => {
        const lessonDetail = lessonDetails;
        lessonDetail.visibility = event.value;
        setLessonDetails(lessonDetail);
    };

    const handleAvailabilityChange = (event) => {
        const lessonDetail = lessonDetails;
        lessonDetail.availability = event.value;
        setLessonDetails(lessonDetail);
    };

    const [selectedFiles, setSelectedFiles] = useState(null);

    const handleFileChange = (event) => {
        setSelectedFiles(event.target.files);
    };

    const handleLessonCategoryChange = (event) => {
        const lessonDetail = lessonDetails;
        lessonDetail.category = event.value;
        setLessonDetails(lessonDetail);
    };

    const [videoType, setVideoType] = useState("vimeo")

    const handleLessonVideoTypeChange = (event) => {
        const lessonDetail = lessonDetails;
        lessonDetail.videoType = event.value;
        setVideoType(event.value)
        
        setSelectedLessonVideo("")

        if(props.lessonToUpdate.videoType == lessonDetail.videoType){
            lessonDetail.video = props.lessonToUpdate.video
            setSelectedLessonVideo(props.lessonToUpdate.video)
        }

        setLessonDetails(lessonDetail);
        
    };

    

    const handleUpdateCategoryLessons = (e) => {
        e.preventDefault()
        Swal.showLoading()

        console.log(lessonDetails)

        if(lessonDetails.title == "" || lessonDetails.visibility == "" || lessonDetails.availability == "" )
        {
            Swal.fire({
                title: 'Failed!',
                text: 'Please fill all the required field!',
                icon : 'error',
                timer: 3000
                
              }
            ).then((result) => {
             
               
            })
        }
        else{
            const formData = new FormData();
            formData.append('id', lessonDetails.id);
            formData.append('title', lessonDetails.title);
            formData.append('category', lessonDetails.category);
            formData.append('thumbnail', lessonDetails.thumbnail);
            formData.append('body', lessonDetails.body);
            formData.append('visibility', lessonDetails.visibility);
             formData.append('availability', lessonDetails.availability);
            formData.append('video', lessonDetails.video);
            formData.append('videoType', lessonDetails.videoType);
            formData.append('oldCategory', lessonDetails.oldCategory);
            if (selectedFiles) {
                for (let i = 0; i < selectedFiles.length; i++) {
                  formData.append('files', selectedFiles[i]);
                }
            }
            formData.append('datCourseId',props.courseData.datCourseId)
            formData.append('handle', props.userDetails.handle);
            dispatch(updateDatCourseLessons(formData))
        }
        
        
    }


    useEffect(() => {
        if(props.fetchDatCourses.datcourses.length){
            
            if(typeof props.courseData.category != "undefined"){
                props.handleCourseResetCallBack(props.fetchDatCourses.datcourses.find(course => course.datCourseId == props.courseData.datCourseId).category)
                
            }
           
            
        }
    },[props.fetchDatCourses])
    
    const reloadCourse = () =>{
        props.handleCourseResetCallBack()
    }

    useEffect(() => {
    
  
        if(props.createDatCourseLessons.datcourse.length && typeof props.createDatCourseLessons.error === "undefined"){
          
          Swal.fire({
              title: 'Success!',
              text: 'Successfully added DAT course lesson!',
              icon : 'success',
              timer: 3000
              
            }
          ).then((result) => {
            setLessonDetails({ 
                id : "",
                title : "",
                thumbnail : "",
                visibility : "",
                availabilty : "",
                body : "",
                category: "",
                oldCategory : "",
                video: "",
                videoType: "vimeo"
            })
            setEditorState(EditorState.createEmpty())
            dispatch(createDatCourseLessonsReset());
            toggleAddDatCourseCategoryLessons()
            dispatch(fetchDatCourses({}))
          })
          
        }
      
        else if(typeof props.createDatCourseLessons.error !== "undefined"){
       
          Swal.fire({
              title:'Failed!',
              text:'Failed to add DAT course lesson!',
              icon :'error',
              timer: 3000
              
            }
          ).then((result) => {
            setLessonDetails({ 
                id : "",
                title : "",
                thumbnail : "",
                visibility : "",
                availabilty : "",
                body : "",
                category: "",
                oldCategory : "",
                video: "",
                videoType: "vimeo"
            })
            setEditorState(EditorState.createEmpty())
           
            dispatch(createDatCourseLessonsReset());
            toggleAddDatCourseCategoryLessons()
             dispatch(fetchDatCourses({}))
          })    
                
        }
      
    }, [props.createDatCourseLessons])

    useEffect(() => {
    
  
        if(props.updateDatCourseLessons.datcourse.length && typeof props.updateDatCourseLessons.error === "undefined"){
          
          Swal.fire({
              title: 'Success!',
              text: 'Successfully updated DAT course lesson!',
              icon : 'success',
              timer: 3000
              
            }
          ).then((result) => {
            setLessonDetails({ 
                id : "",
                title : "",
                thumbnail : "",
                visibility : "",
                availabilty : "",
                body : "",
                category: "",
                oldCategory : "",
                video: "",
                videoType: "vimeo"
            })
            setEditorState(EditorState.createEmpty())
            dispatch(fetchDatCourses({}))
            dispatch(updateDatCourseLessonsReset());
            toggleAddDatCourseCategoryLessons()
          })
          
        }
      
        else if(typeof props.updateDatCourseLessons.error !== "undefined"){
       
          Swal.fire({
              title:'Failed!',
              text:'Failed to update DAT course lesson!',
              icon :'error',
              timer: 3000
              
            }
          ).then((result) => {
            setLessonDetails({ 
                id : "",
                title : "",
                thumbnail : "",
                visibility : "",
                availabilty : "",
                body : "",
                category: "",
                oldCategory : "",
                video: "",
                videoType: "vimeo"
            })
            setEditorState(EditorState.createEmpty())
            dispatch(fetchDatCourses({}))
            dispatch(updateDatCourseLessonsReset());
            toggleAddDatCourseCategoryLessons()
          })    
                
        }
      
    }, [props.updateDatCourseLessons])




    return (
        <div>
            <Modal className="modal-dialog-centered" size="lg" isOpen={modalAddDatCourseCategoryLessons}  toggle={toggleAddDatCourseCategoryLessons}>
                    
                <ModalBody className='modal-body p-0'>
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent">
                            <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">{props.editCourseCategoryLessons ? "Edit" : "Add"} Lesson</h3>
                            </Col>
                            <Col className="text-right" xs="4">
                                
                            </Col>
                            </Row>
                        </CardHeader>
                        <CardBody style={{maxHeight:"650px", overflowY: 'auto'}}>
                            <h6 className="heading-small text-muted mb-4">
                                Lesson Information
                            </h6>
                            <div className="pl-lg-4">
                                <Row>

                                <Col lg="12">
                                        <FormGroup>
    
                                            <label
                                                className="form-control-label"
                                                
                                            >
                                                Video
                                            </label>

                                            { selectedLessonVideo != null && selectedLessonVideo != "" ? 
                                                <>
                                                    {selectedLessonVideo.includes("vimeo")?
                                                        <div className='text-center embed-responsive embed-responsive-16by9 shadow img-thumbnail'>
                                                            
                                                            <iframe src={"//player.vimeo.com/video/"+selectedLessonVideo.split('/').slice(-2, -1).pop()+"?h="+selectedLessonVideo.split('/').pop().split('?').shift()+"&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;"}   width="100%" height="360" frameBorder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen className="embed-responsive-item" picture-in-picture></iframe>

                                                        </div>
                                                        : 
                                                        // <div className='text-center'>
                                                        //     <video
                                                        //         className='shadow img-thumbnail'
                                                        //         alt="Selected Video"
                                                        //         controls
                                                        //         style={{ maxWidth: '100%'}}>
                                                        //             <source src={selectedLessonVideo} type="video/mp4"/>
                                                        //     </video> 
                                                        // </div>
                                                        ""
                                                    }
                                                    
                                                    <br></br>
                                                    
                                                    </> 
                                                // : props.editCourseCategoryLessons != false && !props.lessonToUpdate.video.includes("vimeo") ? 
                                                // <>
                                                //     <div className='text-center'>
                                                //         <video
                                                //             className='shadow img-thumbnail'
                                                //             src={"https://storage.googleapis.com/datdashboard.appspot.com/video-dat-courses-lessons/"+props.lessonToUpdate.video}
                                                //             alt="Selected Video"
                                                //             controls
                                                //             style={{ maxWidth: '100%'}}
                                                //         />
                                                //     </div>
                                                //     <br></br>
                                                //     </> 
                                                : ""
                                            }
                                            {/* <Select 
                                                placeholder='Select Video Type'
                                                options={[{label : "VIMEO", value : "vimeo"},{label : "UPLOAD VIDEO", value : "upload"}]} 
                                                styles={customDropdown }  
                                                onChange={(e) => handleLessonVideoTypeChange(e)}
                                                menuPortalTarget={document.body}
                                                
                                                className='mb-3'
                                                defaultValue={[{label : "VIMEO", value : "vimeo"},{label : "UPLOAD VIDEO", value : "upload"}].find((option) => option.value == lessonDetails.videoType)}
                                                
                                            /> */}
                                            {/* {lessonDetails.videoType == "vimeo" ?  */}
                                            
                                                <Input
                                                    className="form-control-alternative"
                                                    defaultValue={props.editCourseCategoryLessons ?  lessonDetails.video  : ""}
                                                    placeholder='Paste Vimeo link ex. https://vimeo.com/xxxxxxx/xxxxxxx'
                                                    onChange={e => handleLessonVimeoChange(e)}
                                                    type="text"
                                                /> 
                                                
                                                {selectedLessonVideo ? !selectedLessonVideo.includes("vimeo") ? <small className="text-danger">Invalid vimeo video link.</small> : "" : ""}
                                                {/* :  */}
                                                {/* <div className="custom-file text-center ">
                                                    
                                                    <input
                                                        type="file"
                                                        className="custom-file-input"
                                                        accept="video/*"
                                                        onChange={(event) => handleVideoChange(event)}
                                                    />
                                                    <label className="custom-file-label" >{item.video ? <>Selected video file: <span className='text-primary'>{item.video.name}</span></> : "Select video file (max 10mb)"}</label>
                                                    <label className="custom-file-label" >Select video file</label>
                                                </div>
                                            } */}
                                        </FormGroup>
                                    </Col>

                                    <Col lg="12">
                                        <FormGroup>
    
                                            <label
                                                className="form-control-label"
                                                
                                            >
                                                Title <span className='text-danger'>*</span>
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                defaultValue={props.editCourseCategoryLessons ? lessonDetails.title : ""}
                                                
                                                onChange={e => handleLessonTitleChange(e)}
                                                type="text"
                                            />
                                            
                                        </FormGroup>
                                    </Col>

                                    <Col lg="12">
                                        <FormGroup>
    
                                            <label
                                                className="form-control-label"
                                                
                                            >
                                                Category
                                            </label>
                                            <Select 
                                                placeholder='Select Category'
                                                options={selectCategoryLists} 
                                                styles={customDropdown }  
                                                onChange={(e) => handleLessonCategoryChange(e)}
                                                menuPortalTarget={document.body}
                                                

                                                defaultValue={selectCategoryLists.find((option) => option.value == props.categoryId)}
                                                
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    
                                    <Col lg="12">
                                        <FormGroup>
    
                                            <label
                                                className="form-control-label"
                                                
                                            >
                                                Thumbnail
                                            </label>

                                            { selectedLessonThumbnail != null && selectedLessonThumbnail != "" ? 
                                                <>
                                                    <div className='text-center'>
                                                        <img
                                                            className='shadow img-thumbnail'
                                                            src={selectedLessonThumbnail}
                                                            alt="Selected Image"
                                                            style={{ maxWidth: '100%'}}
                                                        />
                                                    </div>
                                                    <br></br>
                                                    </> 
                                                : props.editCourseCategoryLessons != false && props.lessonToUpdate.thumbnail ? 
                                                <>
                                                    <div className='text-center'>
                                                        <img
                                                            className='shadow img-thumbnail'
                                                            src={"https://storage.googleapis.com/pre-dental-tracker.appspot.com/img-dat-courses-lessons/"+props.lessonToUpdate.thumbnail}
                                                            alt="Selected Image"
                                                            style={{ maxWidth: '100%'}}
                                                        />
                                                    </div>
                                                    <br></br>
                                                    </> 
                                                : ""
                                            }

                                            <div className="custom-file text-center ">
                                                
                                                <input
                                                    type="file"
                                                    className="custom-file-input"
                                                    accept="image/*"
                                                    onChange={(event) => handleImageChange(event)}
                                                />
                                                {/* <label className="custom-file-label" >{item.video ? <>Selected video file: <span className='text-primary'>{item.video.name}</span></> : "Select video file (max 10mb)"}</label> */}
                                                <label className="custom-file-label" >Select image file (max 5mb)</label>
                                            </div>
                                            
                                        </FormGroup>
                                    </Col>

                                    <Col lg="12">
                                        <FormGroup>
    
                                            <label
                                                className="form-control-label"
                                                
                                            >
                                                Body
                                            </label>
                                            <Card className="bg-secondary shadow border-0">
                                                <CardHeader >
                                                        <Editor
                                                            className="form-control-alternative"
                                                            editorState={editorState}
                                                            onEditorStateChange={handleChange}
                                                            toolbar={{
                                                            options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'remove', 'history'],
                                                            
                                                        }}
                                                    />
                                                </CardHeader>
                                            </Card>
                                            
                                        </FormGroup>
                                    </Col>
                                    
                                    <Col lg="12">
                                        <FormGroup>
    
                                            <label
                                                className="form-control-label"
                                                
                                            >
                                                Visibility <span className='text-danger'>*</span>
                                            </label>
                                            <Select 
                                                placeholder='Select Visibility'
                                                options={visibilityOptions} 
                                                styles={customDropdown }  
                                                onChange={(e) => handleVisibilityChange(e)}
                                                menuPortalTarget={document.body}
                                                // value={visibilityOptions.find((option) => option.value === watch("inputTerm"))}
                                                defaultValue={props.editCourseCategoryLessons ? visibilityOptions.find((option) => option.value === lessonDetails.visibility) : ""}
                                            />
                                            
                                        </FormGroup>
                                    </Col>

                                     {/* <Col lg="12">
                                        <FormGroup>
    
                                            <label
                                                className="form-control-label"
                                                
                                            >
                                                Availability <span className='text-danger'>*</span>
                                            </label>
                                            <Select 
                                                placeholder='Select Availability'
                                                options={availabilityOptions} 
                                                styles={customDropdown }  
                                                onChange={(e) => handleAvailabilityChange(e)}
                                                menuPortalTarget={document.body}
                                                // value={visibilityOptions.find((option) => option.value === watch("inputTerm"))}
                                                defaultValue={props.editCourseCategoryLessons ? availabilityOptions.find((option) => option.value === lessonDetails.availability) : ""}
                                            />
                                            
                                        </FormGroup>
                                    </Col> */}

                                    <Col lg="12">
                                        <FormGroup>
    
                                            <label
                                                className="form-control-label"
                                                
                                            >
                                                Files
                                                <ul>
                                                    {selectedFiles ? Array.from(selectedFiles).map((file, index) => (
                                                        <li key={index}>{file.name}</li>
                                                    )) : props.editCourseCategoryLessons ? <>
                                                    {props.lessonToUpdate.files.map((value) => { return <li key={value.rawFileName}>
                                                        <a href={"https://storage.googleapis.com/pre-dental-tracker.appspot.com/files-dat-courses-lessons/" + encodeURIComponent(value.filenameWithUuid)} download={value.rawFileName}>{value.rawFileName}</a></li>
                                                    })}

                                                </> : ""}
                                                    
                                                </ul>
                                            </label>
                                           
                                            
                                            <div className="custom-file text-center ">
                                                
                                                <input
                                                    type="file"
                                                    multiple
                                                    className="custom-file-input"
                                                    
                                                    onChange={(event) => handleFileChange(event)}
                                                />
                                                {/* <label className="custom-file-label" >{item.video ? <>Selected video file: <span className='text-primary'>{item.video.name}</span></> : "Select video file (max 10mb)"}</label> */}
                                                <label className="custom-file-label" >Select files</label>
                                            </div>
                                            
                                        </FormGroup>
                                    </Col>

                                </Row>
                            </div>
    
                        
                            
                            
                        </CardBody>
                    </Card>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary"  onClick={toggleAddDatCourseCategoryLessons}>
                        Cancel
                    </Button>
    
                    {props.editCourseCategoryLessons === false ? 
                        <Button color="primary" onClick={e => handleCreateCategoryLessons(e)}>
                            Save
                        </Button>
                        :
                        <Button color="primary" onClick={e => handleUpdateCategoryLessons(e)}>
                            Update
                        </Button>
                    }
                </ModalFooter>
                
            </Modal>
        </div>
    )
}

const mapStateToProps = state  => {
    return {
        userDetails : state.loginAuth.userDetails,
        createDatCourseCategory : state.createDatCourseCategory,
        createDatCourseLessons : state.createDatCourseLessons,
        updateDatCourseLessons : state.updateDatCourseLessons,
         fetchDatCourses : state.fetchDatCourses,
    }
      
}

export default connect(mapStateToProps)(AddDatCourseCategoryLessonsModal)
